import { ExecException } from 'child_process';
type StormApi = 'open_door' | 'get_locker_open_status';
type ErrorCallback = (message: string) => void;
type ResultCallback = (result: string) => void;

export enum LockerStatus {
    Unknown = -1,
    Open = 0,
    Closed = 1
}

export const STORM_API_FILE = '/usr/local/reyrey/storm_zero/drivers/api.py';

export const StormApiOpenLocker = (lockerNumber: number) => StormKioskApi('open_door', lockerNumber);

export const StormApiReadLockerStatus = (lockerNumber: number) =>
    new Promise<LockerStatus>((resolve: (status: LockerStatus) => void, reject: ErrorCallback) => {
        StormKioskApi('get_locker_open_status', lockerNumber)
            .then((output) => {
                if (output.includes('status: open')) {
                    resolve(LockerStatus.Open);
                }
                else if (output.includes('status: closed')) {
                    resolve(LockerStatus.Closed);
                }
                else {
                    resolve(LockerStatus.Unknown);
                }
            })
            .catch((error) => {
                reject(error);
            });
    });

const StormKioskApi = (api: StormApi, options?: any) =>
    new Promise((resolve: ResultCallback, reject: ErrorCallback) => {
        try {
            window.exec(`python3 ${STORM_API_FILE} ${api} ${options ? options : ''}`, (_exeption: ExecException | null, stdout: string, stderr: string) => {
                if (stderr) {
                    const error = `stderr: ${stderr}`;
                    console.log(error);
                    reject(error);
                }
                else {
                    const response = String(stdout);
                    console.log(response);
                    resolve(response);
                }
            });
        }
        catch (e) {
            console.log('Process Exception', e);
            reject('Process exited with exception - ' + e);
        }
    });
